import React from 'react';
import PropTypes from 'prop-types';
import { BrandEngagementStats } from '../../../utils/prop-types/engagement-types';
import StatNumber from '../../stat-number';
import Tooltip from '../../tooltip';
import sharedStyles from '../../../styles/shared.css';
import styles from './styles.css';

const ENGAGEMENT_STATS_MAP = {
  search_impressions: 'Brand Impressions',
  station_impressions: 'Station Impressions',
  gas_prices_spotted: 'Gas Prices Spotted',
  total_reviews: 'Total Reviews',
  station_visits: 'Station Visits',
  avg_dwell_time: 'Avg. Dwell Time',
};

class BrandEngagementContent extends React.Component {
  static propTypes = {
    stats: BrandEngagementStats,
    comparisonStats: BrandEngagementStats,
    comparisonMetricName: PropTypes.string,
  }

  static defaultProps = {
    stats: {},
    comparisonStats: {},
    comparisonMetricName: '',
  }

  renderEngagementRow(statFieldName) {
    const { stats, comparisonStats } = this.props;
    const statName = ENGAGEMENT_STATS_MAP[statFieldName];

    return (
      <tr id="{{categoryClass}}" key={statFieldName} className="engagement-category" data-engagement-type="{{categoryClass}}">
        <td>
          {statName}
        </td>
        <td className="col-start">
          <StatNumber
            statType={statFieldName}
            value={(stats || {})[statFieldName]}
          />
        </td>
        <td className="comparison category-comparison">
          <StatNumber
            statType={statFieldName}
            value={(stats || {})[statFieldName]}
            compareTo={(comparisonStats || {})[statFieldName]}
            showDifference
          />
        </td>
      </tr>
    );
  }

  render() {
    const { comparisonMetricName } = this.props;

    return (
      <table className={`${sharedStyles.stripedTable} ${styles.brandEngagementContent}`}>
        <thead>
          <tr>
            <th>
              <span>
                  Engagement
              </span>
            </th>
            <th>
              <span id="brandEngTotals">
                  Totals
              </span>
              <Tooltip
                tootipContent="This total is based on the engagement category for only this station."
                uniqueTargetSelector="#brandEngTotals"
              />
            </th>
            <th>
              <div id="comparisonMetricSelectContainer" className="comparison-metric-container">
                <span>COMPARE TO</span>
                <br />
                <span>{comparisonMetricName}</span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(ENGAGEMENT_STATS_MAP).map(key => this.renderEngagementRow(key))}
        </tbody>
      </table>
    );
  }
}

export default BrandEngagementContent;
